import { render, staticRenderFns } from "./TableNotifikasiAdmin.vue?vue&type=template&id=019238b6&"
import script from "./TableNotifikasiAdmin.vue?vue&type=script&lang=js&"
export * from "./TableNotifikasiAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TableNotifikasiAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports